import axios from '@/plugins/axios'
import { Module } from 'vuex'

const networkConnectionTypesModule: Module<any, any> = {
    actions: {
        async getNetworkConnectionTypes(_, params) {
            const url = '/api/network_connection_types'
            const { data } = await axios.get(url)
            return data
        },
    },
}

export default networkConnectionTypesModule
